import {useMemo} from 'react'

import type {AddressWithContacts} from './RouteInfo.types'

/** Параметры хука useRemovePointHandlers */
type Options = {
  /** Адреса маршрута */
  addresses: AddressWithContacts[]
  setAddresses: (addresses: AddressWithContacts[]) => void
}

/**
 * Создаёт хэндлеры, вызываемые при удалении точки.
 * @param route Точки маршрута
 */
export const useRemovePointHandlers = ({addresses, setAddresses}: Options) =>
  useMemo(
    () =>
      addresses.map((_, index) => () => {
        const addressesCopy = [...addresses]
        setAddresses(addressesCopy.slice(0, index).concat(addressesCopy.slice(index + 1)))
      }),
    [addresses, setAddresses],
  )
